import React from 'react';

export default function ConfirmModal({ title, message, onConfirm, onCancel }) {
  if (!message) return null;
  return (
    <div className="ov" onClick={onCancel}>
      <div className="mo" onClick={e => e.stopPropagation()} style={{ maxWidth: 340, textAlign: 'center' }}>
        <h3>{title || 'Confirmar'}</h3>
        <p style={{ margin: '12px 0 20px', fontSize: 14, color: 'var(--c4)' }}>{message}</p>
        <div className="btn-g" style={{ justifyContent: 'center' }}>
          <button className="btn btn3" onClick={onCancel}>Cancelar</button>
          <button className="btn btn2" onClick={onConfirm}>Confirmar</button>
        </div>
      </div>
    </div>
  );
}
